import React from 'react'

import classes from './style.module.css'

export type NegativeGroupsPayload = {
  groups?: string[]
}

interface NegativeStatusProps {
  data?: NegativeGroupsPayload | null
  hideEmpty?: boolean
}

const NegativeStatus: React.FC<NegativeStatusProps> = ({ data, hideEmpty }) => {
  if (hideEmpty && !data?.groups?.length) return null

  return (
    <p className="p-0 m-0" style={{ color: 'rgb(0,0,0)' }}>
      Н:&nbsp;
      {data?.groups?.length ? (
        <>
          {data?.groups?.includes('Н0') ? <span className={classes.yellowBackgroundColor}>Н0{data?.groups.length > 1 ? ', ' : null}</span> : null}
          <span>{data?.groups?.filter((item: string) => item !== 'Н0')?.join(', ')}</span>
        </>
      ) : (
        <span>Н?</span>
      )}
    </p>
  )
}

export default NegativeStatus
